import Text from 'components/shared/Text'
import Box from 'components/shared/Box'
import Quantity from 'components/global/Quantity'
import { formatPrice } from 'helpers/helpers'
import Price from 'components/shared/Price'
import { SummaryItemWrapper } from 'components/global/Summary/styles'

export interface SummaryItemProps {
    name: string
    description?: string
    quantity: number
    price: number
    totalPrice: number
    totalPriceWithoutDiscount: number
    hasPromotion?: boolean
    isAccoomodation?: boolean
    isTruncable?: boolean
}

export const SummaryItem = ({
    name,
    description,
    quantity,
    price,
    totalPrice,
    totalPriceWithoutDiscount,
    hasPromotion,
    isTruncable,
}: SummaryItemProps) => (
    <SummaryItemWrapper gap={8} direction="row" isTruncable={isTruncable}>
        <Quantity value={quantity} size="small" />
        <Box gap={4} mt={2} isFullWidth>
            <Box direction="row" isFullWidth justify="space-between" gap={4}>
                <Box>
                    <Text
                        variant="bodySmall"
                        color="grayscale_900"
                        truncateAfter={isTruncable ? 2 : undefined}
                    >
                        {name}
                    </Text>
                    {!!description && (
                        <Text
                            variant="bodyExtraSmall"
                            color="grayscale_700"
                            dangerouslySetInnerHTML={{
                                __html: description,
                            }}
                        ></Text>
                    )}
                </Box>
                <Box align="flex-end" className="summaryPrice">
                    <Text variant="bodySmall" color="primary_500" hasNoWrap>
                        {hasPromotion
                            ? formatPrice(totalPrice, true)
                            : formatPrice(price, true)}
                    </Text>
                    {hasPromotion && (
                        <Price
                            value={totalPriceWithoutDiscount}
                            size="bodyExtraSmall"
                            color="grayscale_700"
                            crossedOutVariant="yellow"
                        />
                    )}
                </Box>
            </Box>
            <Box direction="row" justify="space-between" isFullWidth></Box>
        </Box>
    </SummaryItemWrapper>
)
